export class LISSResolutionAction {
    id: number;
    name: string;
    fieldNames: string[];

    constructor(data?: Partial<LISSResolutionAction>) {
        Object.assign(this, data);
    }
}

export class LISSResolutionRule {
    id: number;
    lissConsumptionID: number;
    requirementID: number;
    name: string;
    actionID?: number;
    actionData1: string;
    actionData2: string;
    executeForAll: boolean;
    availableResolutions: LISSResolutionAction[];
    action: LISSResolutionAction;

    get isValid(): boolean {
        if (!this.actionID) return false;

        if (!this.action) return false;

        if (this.action.fieldNames.length > 0 && !this.actionData1)
            return false;

        if (this.action.fieldNames.length > 1 && !this.actionData2)
            return false;

        return true;
    }

    constructor(data?: Partial<LISSResolutionRule>) {
        Object.assign(this, data);

        this.availableResolutions =
            this.availableResolutions?.map(
                resolution => new LISSResolutionAction(resolution),
            ) ?? [];

        this.action = new LISSResolutionAction(this.action);
    }
}
